import { Component, OnInit, ViewContainerRef, EventEmitter, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { CruiseService } from '../services/cruise.service';
import { RechargeService } from '../services/recharge.service';
import { PLATFORM_ID, Inject } from '@angular/core';
import { PlatformLocation, isPlatformServer, isPlatformBrowser } from '@angular/common';

// import { HttpClient, HttpEventType } from '@angular/common/http';
declare var jQuery: any;
declare var window: any;
declare var $: any;
declare var moment: any;

@Component({
    selector: 'app-recharge',
    templateUrl: './recharge.component.html',
    styleUrls: ['./recharge.component.css'],
    providers: [CruiseService, DatePipe]
})
export class RechargeComponent implements OnInit {

    public username: any;
    public password: any; public planListarray: any = []; public planList: any = [];
    public isAgentLoggedIn: any = false; private imageError: any = ''; public rechargeBundle: any = {}; public activationBundle: any = {};
    public portaltype: any = '';
    public email: any = ''; public circleName: any = ''; public operatorName: any = '';
    public Bookingref: any = ''; public Operatorslist: any = [];
    public ticketUrls: any = ""; public rechargeData: any = {}; public registerStatus: any = [];
    public filename: any = ""; public circle: any = ''; public BillerID: any = ''; public operator: any = '';
    public trans: any = "";
    public GSTNdiv: any = ''; public mobile: any = ""; public operatorSelect: any = ""; public planType: any = "";
    public Callagentremarks: any = ''; public availableMedia: any = []; public availableMediaLogo: any = [];
    public Callagentemail: any = ''; public amount: any = ""; public activationlist: any[]; public rechargelist: any[];
    public Callmobile: any = ''; public balancestr: any = 0; public availableSIMS: any = [];
    private merchantsetup: any = {};
    private merchantsetups: any = {};
    fileData: File = null;
    previewUrl: any = null;
    fileUploadProgress: string = null;
    uploadedFilePath: string = null;
    public logo: any = "http://flights.ibe4all.com/images/logo.jpg";
    public fileUrl: any;
    public file: File = null; private base64string: any = ''; private fileName: any = ''; private baseURL: any = ''; private fullURL: any = '';
    public activationplan: any = ''; public sim: any = ''; public firstname: any = ''; public lastname: any = ''; public simNo: any = '';
    public postalcode: any = ''; public address1: any = ''; public address2: any = ''; public state: any = ''; paymentInitiate: any = "";
    public traveldate: any = ''; public passport: any = ''; public altmobile: any = ''; public visaimage: any = ''; public passportimage: any = ''; public ticketimage: any = '';
    // Labels
    public logintxt: any = 'Agent Sign In'; public signuptxt: any = 'Agent Sign Up';
    public loginType = ''; private logindata: any = ''; private rooms: any = ''; public refcode: any; public agentcode: any = "";
    public contact: any = ''; memail: any = ''; mname: any = ''; public about: any = ''; AgentUserLoginId: any = ''; userType: any = '';
    public options: any = {
        autoApply: true,
        "locale": { "format": "DD/MM/YYYY" },
        singleDatePicker: true,
        showDropdowns: true,
        minDate: moment().format('DD-MM-YYYY'),
    };

    constructor(@Inject(PLATFORM_ID) private platformId: Object,
        private loginService: CruiseService, private toastr: ToastrService, private vcr: ViewContainerRef, private titleService: Title, private meta: Meta,
        public router: Router, platformLocation: PlatformLocation, private rechargeService: RechargeService, private datePipe: DatePipe) {
        this.baseURL = (platformLocation as any).location.origin; this.fullURL = (platformLocation as any).location.pathname;
        this.merchantsetup = this.loginService.getSetupData();
        this.loginType = this.loginService.getloginType(); this.titleService.setTitle("International SIM cards, eSIMS and data solutions while traveling abroad");
        this.meta.addTag({ name: 'Description', content: "Your one-stop-shop for international SIM cards, eSIMS and data solutions while traveling abroad. Stay connected with our seamless, affordable, and reliable mobile connectivity wherever you go and enjoy free incoming. Explore our range of products and enjoy a worry-free travel experience." });
        this.meta.addTag({ name: 'Keywords', content: "International Sim Card | eSim | Prepaid Roaming Sim Card" });
        // Get Agent Login
        if (isPlatformBrowser(this.platformId)) {
            try {
                if (sessionStorage.getItem("logindata")) {
                    this.logindata = JSON.parse(JSON.parse(sessionStorage.getItem("logindata")));
                    this.balancestr = this.logindata.CurrentBalance;
                    this.username = this.logindata.AgentUserLoginId;
                    this.userType = this.logindata.Type;
                    this.agentcode = this.logindata.CompanyCode;
                    // if (this.totalCost > this.balancestr) this.insufficient = "T"

                }
                else {
                    this.toastr.warning("You don't have permission to view this...!");
                    setTimeout(() => {
                        this.router.navigate([""]);
                    }, 2000);
                }
            } catch (errormsg) { console.log(errormsg) };
        }

        if (this.merchantsetup.portaltype == "B2B") {
            if (!sessionStorage.getItem("isAgentLoggedIn")) {
                this.router.navigate(["login"]);
            }
        }
    }

    ngOnInit() {

        // setTimeout(() => {
        //     this.traveldate = this.datePipe.transform(new Date(), 'dd/MM/yyyy');
        // }, 1000);
        this.getRechargePlans('call'); this.getActivationPlans('call');
    }
    home() {
        this.router.navigate(["/"]);
    }

    keyPress(event: any) {
        const pattern = /[0-9\ ]/;

        let inputChar = String.fromCharCode(event.charCode);
        if (event.keyCode != 8 && !pattern.test(inputChar)) {
            event.preventDefault();
        }
    }

    onlyAlphabets(e: any) {
        try {
            if (window.event) {
                var charCode = window.event.keyCode;
            }
            else if (e) {
                var charCode = e.which;
            }
            else { return true; }
            if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || (charCode == 32))
                return true;
            else
                return false;
        }
        catch (err) {
        }
    }

    switchTabs(tabName) {
        if (tabName == "NewActivation") {
            this.mobile = ""; this.amount = ""; this.activationlist = []; this.getActivationPlans('call');//this.getActivationPlans();
        }
        if (tabName == "RechargeBundle") {
            this.rechargelist = []; this.mobile = ""; this.amount = ""; this.getRechargePlans('call');
            // this.getRechargePlans('call');
        }
    }

    makeItBlank(event) {
        jQuery(event.target).val("");
    }

    fillItBack(event, type) {
        if (type == 'mobile')
            jQuery(event.target).val(this.mobile);
        else
            jQuery(event.target).val(this.mobile);
        this.operatorSelect = event.target.value;
    }

    showPlanDetails() {
        // //billerid()circle()()()()()()()()()()()()()^&*Get^&*ezeeibe^&*fetchplans
        // this.planList = [];
        // for (let item of this.Operatorslist) {
        //   // if (item.OperatorName == this.operatorName) {
        //   var Circle = item.Circle; var BillerID = item.BillerID;
        //   break;

        // }
        // this.utilityService.fetchplans(BillerID, Circle, this.logintype, this.agentcode, this.agentid, 'Get', 'fetchplans').subscribe(
        //   data => {
        //     if (JSON.parse(JSON.stringify(data)).d) {
        //       var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d).data;
        //       this.planList = resp;
        //       // for (let item of this.planList) {
        //       //   var Circle = item.recharge_short_description;
        //       //   Circle==Circle;
        //       //   this.dropdownarray=item.recharge_short_description;
        //       // }
        //       //let arr = [];
        //       for (let i = 0; i < this.planList.length; i++) {
        //         if (!this.dropdownarray.includes(this.planList[i].recharge_short_description)) {
        //           this.dropdownarray.push(this.planList[i].recharge_short_description);
        //         }
        //       }
        //     }
        //   }
        // )
    }

    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    setSimNo(Name, id, sid) {
        this.simNo = Name; this.availableSIMS = [];
    }

    ProceedRecharge($event) {
        if (!this.mobile) {
            this.toastr.warning("Please provide mobile ...!");
            return false;
        }
        if (!this.amount) {
            this.toastr.warning("Please select one of the Plans from List ...!");
            return false;
        }

        if ((this.amount > parseInt(this.balancestr)) && this.userType != "OO" && this.userType != "OOU") {
            this.toastr.warning("Wallet Balance in not enough. please top-up your Wallet...!");
            return false;
        }

        this.paymentInitiate = "initiate";

        //categotycode()billerid()statecode()citycode()circle()amount()()()()()()()()()()^&*Get^&*ezeeibe^&*billpay
        this.rechargeService.rechargePlan(this.mobile, JSON.stringify(this.rechargeBundle), JSON.stringify(this.logindata), this.agentcode, this.AgentUserLoginId, "Get", "recharge").subscribe(
            data => {
                if (JSON.parse(JSON.stringify(data)).d) {
                    var resp1 = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                    if (resp1.Status == "Success") {
                        this.toastr.success(resp1.Message);
                    } else { this.toastr.error(resp1.MessageData); }
                    this.paymentInitiate = ""; this.amount = "";
                }
            }, error => {
                console.log("ProceedToPayment Error .....");
            }
        )
    }

    ProceedActivation($event) {
        this.traveldate = jQuery('#flightDepart').val();
        if (!this.amount) {
            this.toastr.warning("Please select one of the Plans from List ...!");
            return false;
        }
        if (!this.firstname) {
            this.toastr.warning("First Name required ...!");
            return false;
        }
        if (!this.lastname) {
            this.toastr.warning("Last Name required ...!");
            return false;
        }
        if (!this.address1) {
            this.toastr.warning("Address required ...!");
            return false;
        }
        if (!this.state) {
            this.toastr.warning("State required ...!");
            return false;
        }
        if (!this.passport) {
            this.toastr.warning("Postal Code required ...!");
            return false;
        }
        if (!this.traveldate) {
            this.toastr.warning("Travel Date required ...!");
            return false;
        }
        // if (!this.visaimage) {
        //     this.toastr.warning("Visa Copy required ...!");
        //     return false;
        // }
        if (!this.passportimage) {
            this.toastr.warning("Passport Copy required ...!");
            return false;
        }
        // if (!this.ticketimage) {
        //     this.toastr.warning("Ticket Copy required ...!");
        //     return false;
        // }
        if (!this.sim) {
            this.toastr.warning("Select SIM type ...!");
            return false;
        }
        let d = {
            sim: this.sim,
            firstname: this.firstname,
            lastname: this.lastname,
            address1: this.address1,
            address2: (this.address2),
            state: this.state,
            postalcode: this.postalcode,
            passport: this.passport,
            traveldate: this.traveldate,
            visaimage: this.visaimage,
            passportimage: this.passportimage,
            ticketimage: this.ticketimage,
            refcode: this.refcode,
            simNo: this.simNo,
            altmobile: this.altmobile,
            email: this.email
        };
        if ((this.amount > parseInt(this.balancestr)) && this.userType != "OO" && this.userType != "OOU") {
            this.toastr.warning("Wallet Balance in not enough. please top-up your Wallet...!");
            return false;
        }

        this.paymentInitiate = "initiate";
        //categotycode()billerid()statecode()citycode()circle()amount()()()()()()()()()()^&*Get^&*ezeeibe^&*billpay
        this.rechargeService.rechargePlan(this.mobile, JSON.stringify(this.activationBundle), JSON.stringify(this.logindata), JSON.stringify(d), this.AgentUserLoginId, "Get", "activate").subscribe(
            data => {
                if (JSON.parse(JSON.stringify(data)).d) {
                    var resp1 = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                    if (resp1.Status == "Success") {
                        this.toastr.success(resp1.MessageData);
                    } else { this.toastr.error(resp1.MessageData); }
                    this.paymentInitiate = ""; this.amount = "";
                }
            }, error => {
                console.log("ProceedToPayment Error .....");
            }
        )
    }

    getActivationPlans(typ) {
        this.activationlist = [];
        this.rechargeService.fetchactivationplans("", "", "", "", typ, 'Get', 'activationplans').subscribe(
            data => {
                if (JSON.parse(JSON.stringify(data)).d) {
                    var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                    this.activationlist = resp;
                    this.sort();
                }
            }
        )
    }

    selectPlan(profile) {
        this.activationBundle = profile; this.activationplan = profile.profile; this.amount = profile.price;
    }

    readLogoFile(event: any, filetype) {
        var base64 = this.imgtobase64(event, filetype);
        if (base64 == false) {
            this.toastr.warning(this.imageError)
            return false;
        }
        // setTimeout(() => {
        //     if (filetype == "visa") this.visaimage = this.base64string;
        //     if (filetype == "passport") this.passportimage = this.base64string;
        //     if (filetype == "ticket") this.ticketimage = this.base64string;
        // }, 1000);
    }

    imgtobase64(fileInput: any, dataType: any) {
        this.imageError = ''; var cardImageBase64 = "";
        if (fileInput.target.files && fileInput.target.files[0]) {
            if (fileInput.target.files[0].name.toUpperCase().indexOf("PNG") > -1 || fileInput.target.files[0].name.toUpperCase().indexOf("JPEG") > -1 || fileInput.target.files[0].name.toUpperCase().indexOf("JPG") || fileInput.target.files[0].name.toUpperCase().indexOf("PDF") > -1) {
                // Size Filter Bytes
                const max_size = 2097152;

                if (fileInput.target.files[0].size > max_size) {
                    this.imageError =
                        'Maximum size allowed is ' + max_size / 1000000 + 'Mb';

                    return false;
                }

                this.filename = fileInput.target.files[0].name;

                const reader = new FileReader();
                reader.onload = (e: any) => {
                    const imgBase64Path = e.target.result;
                    //console.log(imgBase64Path);
                    if (dataType == "visa") this.visaimage = imgBase64Path;
                    if (dataType == "passport") this.passportimage = imgBase64Path;
                    if (dataType == "ticket") this.ticketimage = imgBase64Path;
                    this.base64string = imgBase64Path;
                };
                reader.readAsDataURL(fileInput.target.files[0]);
            } else { this.toastr.warning("Choose the correct file. Need a Png,Jpeg file"); }
        }
    }

    getRechargePlans(typ) {
        this.rechargelist = [];
        this.rechargeService.fetchactivationplans("", "", "", "", typ, 'Get', 'rechargeplans').subscribe(
            data => {
                if (JSON.parse(JSON.stringify(data)).d) {
                    var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                    this.rechargelist = resp; this.sort();
                }
            }
        )
    }

    selectPlanRecharge(profile) {
        this.rechargeBundle = profile; this.amount = profile.price;
    }

    getsimNos(event, i?) {
        let term = event.target.value;
        {
            if (term.length > 2) {
                this.rechargeService.fetchactivationplans(term, "", "", "", "", 'Get', 'getesim').subscribe(
                    data => {
                        if (JSON.parse(JSON.stringify(data)).d) {
                            var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                            this.availableSIMS = resp.eSIM;
                        }
                    })
            }
        }
    }

    rechargePlanData(typ) {
        this.rechargeBundle = []; this.getRechargePlans(typ);
    }

    activationPlanData(typ) {
        this.activationBundle = [];
        this.getActivationPlans(typ);
    }

    sort() {
        this.rechargelist = this.rechargelist.sort((a, b) => a.price - b.price);
        this.activationlist = this.activationlist.sort((a, b) => a.price - b.price);

    }
}